<template>
  <div class="row gallery">
    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3" v-for="(item, index) in images">
      <div class="thumbnail">
        <img :data-src="item.imageUrl" :data-image-id="item.id" class="lazyload" @click="setActive(index)" title="Click to open">
        <div class="caption">
        <p>Photo {{index+1}}</p>
        <p class="hidden-print" v-if="!readonly"><a @click.stop.prevent="remove(item.id)"><i class="fa fa-trash-o" aria-hidden="true"></i>Remove</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import { dialogBox } from '../js/utils.js'
  export default {
    props: {
      images: Array,
      readonly: {
        type: Boolean,
        default: false
      },
      url: {
          type: String,
          required: true
      },
    },
    methods: {
      setActive (idx) {
        this.$emit('changeIndex', idx)
      },
      remove(image_id) {
        dialogBox('Confirmation', 'Delete this photo ? This action can not be undone.', {0: 'OK', 1: 'Cancel'}).then(r => {
          if (r == 0) {
            this.$emit('removeImage', image_id)
          }
        });
      }
    }
  }
</script>

<style lang="sass" scoped>
.gallery {
  img {
    width: 100%;
    height: 120px;
    display: block;
  }
  .thumbnail {
    a {
      cursor: pointer;
      i.fa.fa-trash-o {
        margin-right: 4px;
      }
    }
  }
}
</style>
